<template>
    <header class="header">
        <navbar :class="$route.name !== 'login' ? '' : 'nav_login'" />
    </header>
    <sidebar
        v-if="$route.name !== 'login' && $route.name !== 'invoice'"
        :routeName="routeName"
        @collapse-change="sidebarCollapsed = $event"
    />
    <main
        class="main" 
        :class="[
            $route.name === 'login' ? 'main_login' : '',
            $route.name === 'invoice' ? 'main_invoice' : '',
            $route.meta.group === 'game' ? 'game' : '',
            sidebarCollapsed && !['login', 'invoice'].includes($route.name) && $route.meta.group !== 'game' ? 'sidebar-collapsed' : ''
        ]"
    >
        <router-view v-slot="{ Component }">
            <Transition name="fade">
                <component :is="Component" />
            </Transition>
        </router-view>
        <!-- <div
            v-if="$route.name !== 'login'"
            class="bg_bottom"
        ></div> -->
    </main>
    <div v-if="isLoading" class="preloader-wrapper">
        <div class="preloader preloader_1"></div>
        <div class="preloader preloader_2"></div>
    </div>
    <NewNotificationModal :item="new_notification" />
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import NewNotificationModal from "@/components/modals/notification/NewNotificationModal.vue";
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            routeName: "home",
            sidebarCollapsed: localStorage.getItem("sidebar-collapsed") === "true",
            snowTimer: null,
            snowElements: [],
        };
    },

    components: {
        Navbar,
        Sidebar,
        NewNotificationModal
    },

    computed: {
        ...mapState({
            token: (state) => state.token,
            isLoading: (state) => state.isLoading,
            new_notification: (state) => state.notifications.new_notification,
            // newYearStatus: state => state.newYearStatus
        }),
    },

    methods: {
        ...mapActions({
            getProfileData: "getProfileData",
            fetchNotifications: "notifications/fetchNotifications"
        }),

        applySnow() {
            const snowmax = window.innerWidth < 768 ? 45 : 200;
            const snowcolor = ["#1f9ff0", "#0c90f6", "#aed2ed", "#03bdfa", "#c8ddf1"];
            const snowtype = ["Times"];
            const snowletter = "❄";
            const sinkspeed = 0.1;
            const snowmaxsize = window.innerWidth < 768 ? 10 : 30;
            const snowminsize = 10;
            const snowingzone = 1;

            let marginbottom = document.documentElement.clientHeight + 50;
            let marginright = document.body.clientWidth - 15;

            const random = (n) => Math.floor(Math.random() * n);

            const snow = [];
            const crds = [];
            const lftrght = [];
            const x_mv = [];

            for (let i = 0; i < snowmax; i++) {
                const span = document.createElement("span");

                span.innerHTML = snowletter;
                span.style.position = "fixed";
                span.style.pointerEvents = "none";
                span.style.userSelect = "none";
                span.style.zIndex = 1000;

                span.size = random(snowmaxsize - snowminsize) + snowminsize;
                span.style.fontSize = span.size + "px";
                span.style.color = snowcolor[random(snowcolor.length)];
                span.style.fontFamily = snowtype[random(snowtype.length)];

                span.sink = sinkspeed * span.size / 5;
                span.posx = random(marginright - span.size);
                span.posy = random(marginbottom);

                span.style.left = span.posx + "px";
                span.style.top = span.posy + "px";

                crds[i] = 0;
                lftrght[i] = Math.random() * 15;
                x_mv[i] = 0.005 + Math.random() / 50;

                document.body.appendChild(span);

                snow[i] = span;
                this.snowElements.push(span);
            }

            const moveSnow = () => {
                for (let i = 0; i < snow.length; i++) {
                    crds[i] += x_mv[i];
                    snow[i].posy += snow[i].sink;

                    snow[i].style.top = snow[i].posy + "px";
                    snow[i].style.left =
                        snow[i].posx + lftrght[i] * Math.sin(crds[i]) + "px";

                    if (snow[i].posy > marginbottom) {
                        snow[i].posy = -snow[i].size;
                        snow[i].posx = random(marginright - snow[i].size);
                    }
                }

                this.snowTimer = requestAnimationFrame(moveSnow);
            };

            moveSnow();
        },

        removeSnow() {
            if (this.snowTimer) {
                cancelAnimationFrame(this.snowTimer);
                this.snowTimer = null;
            }

            this.snowElements.forEach(el => el.remove());
            this.snowElements = [];
        }
    },

    updated() {
        this.routeName = this.$route.name;
    },

    mounted() {
        if (this.token) {
            this.getProfileData();
            this.fetchNotifications();
        }

        // запуск снега
        if (this.$route.name !== "login" && this.newYearStatus) {
            this.applySnow();
        }
    },

    beforeUnmount() {
        // очистка снега
        if(this.newYearStatus) {
            this.removeSnow();
        }
    },

    watch: {
        newYearStatus(newVal) {
            if(newVal) {
                this.applySnow();
            } else {
                this.removeSnow();
            }
        }
    }
};
</script>

<style scoped lang="sass">
.bg_bottom
    position: absolute
    bottom: 0
    left: 0
    margin-top: 48px
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    height: 100px
    background: url('~@/assets/img/decals/bg_bottom.svg')
    // background: url('~@/assets/img/decals/bg_bottom_new_year.svg')
</style>
